"use client";
import { ChoicePills } from "@/components/marketing";
import { cn } from "@/lib/utils";
import type {
  EvidenceFilter,
  EvidenceItem,
  EvidenceKey,
} from "../../data";
import { useEvidenceFilter } from "../../hooks";
import { evidenceToneClass } from "../evidenceTag/evidenceTag.component";

interface EvidenceFilterBarProps {
  ariaLabel: string;
  options: { key: EvidenceFilter; label: string }[];
  keys: EvidenceKey[];
  // Every evidence card on the page, to count the highlighted ones.
  items: EvidenceItem[];
  allText: string;
  // "Highlighting {n} items".
  someTemplate: string;
}

// "How to read this page": the evidence-type filter, a live count and the
// colour key for the four labels.
const EvidenceFilterBar = ({
  ariaLabel,
  options,
  keys,
  items,
  allText,
  someTemplate,
}: EvidenceFilterBarProps) => {
  const { show, setShow } = useEvidenceFilter();
  const count = items.filter((item) => item.kind === show).length;
  const status =
    show === "all" ? allText : someTemplate.replace("{n}", String(count));

  return (
    <div className="grid gap-3">
      <ChoicePills
        ariaLabel={ariaLabel}
        options={options}
        value={show}
        onChange={setShow}
      />
      <p aria-live="polite" className="text-[15px] font-bold text-ink-muted">
        {status}
      </p>
      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {keys.map((key) => (
          <li
            key={key.kind}
            className={cn(
              "grid gap-1 rounded-[20px] px-4 py-3.5 text-sm",
              evidenceToneClass[key.kind],
            )}
          >
            <b className="text-[14.5px]">{key.label}</b>
            <span>{key.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EvidenceFilterBar;
